"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledApFooterRightContent = exports.StyledApFooterLeftContent = exports.StyledApFooterDisclaimer = exports.StyledApFooterRow = exports.StyledApFooterInner = exports.StyledApFooter = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledApFooter = styled_components_1.default.footer({
    backgroundColor: theme_1.colors.black,
    overflow: 'hidden',
    padding: theme_1.scaffolding.xl + " " + theme_1.scaffolding.md
}, function (_a) {
    var _b;
    var padding = _a.padding;
    return (_b = {},
        _b[theme_1.mediaQuery(theme_1.breakpoints.md)] = {
            padding: theme_1.scaffolding.xl + " " + (padding ? padding.md : '40px')
        },
        _b);
});
exports.StyledApFooterInner = styled_components_1.default.div({
    margin: '0px auto',
    width: '100%'
}, function (_a) {
    var isFluid = _a.isFluid;
    return ({
        maxWidth: isFluid ? '100%' : theme_1.breakpoints.xxl
    });
});
exports.StyledApFooterRow = styled_components_1.default.div({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    margin: '0px auto',
    width: '100%'
});
var commonStyles = __assign(__assign({}, theme_1.font), { boxSizing: 'border-box', color: theme_1.colors.white, display: 'inline-flex', minHeight: theme_1.scaffolding.xl, position: 'relative' });
exports.StyledApFooterDisclaimer = styled_components_1.default.div(__assign(__assign({}, commonStyles), { fontSize: '11px', lineHeight: '13px', width: '100%' }));
exports.StyledApFooterLeftContent = styled_components_1.default.div(__assign(__assign({}, commonStyles), { flexBasis: '100%', justifyContent: 'flex-start', marginBottom: theme_1.scaffolding.lg }), function (_a) {
    var alignItems = _a.alignItems;
    return ({
        alignItems: alignItems
    });
});
exports.StyledApFooterRightContent = styled_components_1.default.div(__assign(__assign({}, commonStyles), { flexBasis: '100%', justifyContent: 'flex-end', marginBottom: theme_1.scaffolding.lg }), function (_a) {
    var alignItems = _a.alignItems;
    return ({
        alignItems: alignItems
    });
});
//# sourceMappingURL=styles.js.map